import { mix } from 'polished';
import { css } from 'styled-components';
import { cubicEaseOut } from './animate';
import brand from './brand';
import fonts from './fonts';
import { Device, from } from './media';
const headingStyles = css `
  color: currentColor;
  ${fonts.helvetica.bold};
  margin: 0 0 1em;
`;
export const h1 = css `
  ${headingStyles};
  font-size: 42px;
  line-height: 50px;
  letter-spacing: -0.01em;

  @media ${from(Device.TabletSmall)} {
    font-size: 56px;
    line-height: 66px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 68px;
    line-height: 78px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 72px;
    line-height: 82px;
  }
`;
export const h2 = css `
  ${headingStyles};
  font-size: 36px;
  line-height: 44px;
  letter-spacing: -0.01em;

  @media ${from(Device.TabletSmall)} {
    font-size: 45px;
    line-height: 55px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 52px;
    line-height: 62px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 56px;
    line-height: 68px;
  }
`;
export const h3 = css `
  ${headingStyles};
  font-size: 30px;
  line-height: 38px;
  letter-spacing: -0.01em;

  @media ${from(Device.TabletSmall)} {
    font-size: 33px;
    line-height: 43px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 35px;
    line-height: 45px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 40px;
    line-height: 52px;
  }
`;
export const h4 = css `
  ${headingStyles};
  font-size: 25px;
  line-height: 33px;
  letter-spacing: -0.01em;

  @media ${from(Device.TabletSmall)} {
    font-size: 28px;
    line-height: 38px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 30px;
    line-height: 40px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 32px;
    line-height: 44px;
  }
`;
export const h5 = css `
  ${headingStyles};
  font-size: 20px;
  line-height: 28px;
  letter-spacing: -0.01em;

  @media ${from(Device.TabletSmall)} {
    font-size: 23px;
    line-height: 33px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 25px;
    line-height: 35px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 28px;
    line-height: 40px;
  }
`;
export const h6 = css `
  ${headingStyles};
  ${fonts.helvetica.regular};
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.01em;

  @media ${from(Device.TabletSmall)} {
    font-size: 18px;
    line-height: 28px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 20px;
    line-height: 30px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 22px;
    line-height: 34px;
  }
`;
export const h6Bold = css `
  ${headingStyles};
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.01em;

  @media ${from(Device.TabletSmall)} {
    font-size: 18px;
    line-height: 28px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 20px;
    line-height: 30px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 22px;
    line-height: 34px;
  }
`;
export const subhead = css `
  ${headingStyles};
  ${fonts.helvetica.regular};
  font-size: 22px;
  line-height: 30px;
  letter-spacing: -0.01em;

  @media ${from(Device.TabletSmall)} {
    font-size: 24px;
    line-height: 32px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 24px;
    line-height: 32px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 28px;
    line-height: 40px;
  }
`;
export const headingUnderline = css `
  position: relative;
  padding-bottom: 16px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    background: ${brand.yellow.base};
    height: 10px;
    width: 80px;
    transform: scaleX(0);
    transform-origin: 0 0;
    will-change: transform;
    transition: transform 0.75s cubic-bezier(0.33, 1, 0.68, 1);

    [data-inview='true'] & {
      transform: scaleX(1);
    }
  }
`;
const paragraphStyles = css `
  color: currentColor;
  ${fonts.helvetica.regular};
  margin: 0 0 1em;
`;
export const paragraphHero = css `
  ${paragraphStyles};
  font-size: 20px;
  line-height: 28px;
  letter-spacing: -0.01em;

  @media ${from(Device.TabletSmall)} {
    font-size: 18px;
    line-height: 28px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 18px;
    line-height: 28px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 18px;
    line-height: 32px;
  }
`;
export const paragraph = css `
  ${paragraphStyles};
  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.01em;

  @media ${from(Device.TabletSmall)} {
    font-size: 18px;
    line-height: 28px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 18px;
    line-height: 28px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 18px;
    line-height: 28px;
  }
`;
export const paragraphSmall = css `
  ${paragraphStyles};
  font-size: 16px;
  line-height: 26px;
  letter-spacing: -0.01em;

  @media ${from(Device.TabletSmall)} {
    font-size: 16px;
    line-height: 26px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 16px;
    line-height: 26px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 16px;
    line-height: 28px;
  }
`;
export const micro = css `
  ${fonts.helvetica.bold};
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.01em;

  @media ${from(Device.TabletSmall)} {
    font-size: 14px;
    line-height: 24px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 14px;
    line-height: 24px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 14px;
    line-height: 26px;
  }
`;
export const contentSub = css `
  ${fonts.helvetica.regular};
  font-size: 14px;
  line-height: 26px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;
export const link = css `
  color: currentColor;
  background: linear-gradient(
    to right,
    var(--accentColor, ${brand.blue.base}),
    var(--accentColor, ${brand.blue.base})
  );
  background-repeat: no-repeat;
  background-size: 0% 100%;
  padding: 0.25em 4px;
  text-decoration: underline;
  text-underline-position: under;
  transition: background-size 0.15s ${cubicEaseOut}, color 0.15s ${cubicEaseOut};
  box-decoration-break: clone;

  &:focus {
    outline: none;
  }

  &:focus,
  &:hover {
    background-size: 100% 100%;
    color: ${brand.white};
  }
`;
export const tag = css `
  ${fonts.helvetica.regular};
  font-size: 12px;
  letter-spacing: 0.1em;
  line-height: 1em;
  text-transform: uppercase;
`;
export const blockquote = css `
  ${paragraph};
  position: relative;
  padding: 8px 0 8px 20px;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background-color: ${brand.grey.grey1};
  }
`;
export const tagBold = css `
  ${tag};
  ${fonts.helvetica.bold};
`;
export const table = css `
  background: ${brand.white};
  border-collapse: collapse;
  color: ${brand.black};
  margin-bottom: 1em;
  width: 100%;

  thead {
    tr {
      background: ${brand.blue.base};

      td,
      th {
        border: 2px solid ${brand.white};
        color: ${brand.white};
        ${fonts.helvetica.bold};
        font-size: 18px;
        letter-spacing: -0.01em;
        line-height: 22px;
        padding: 12px 16px;
        text-align: left;
      }
    }
  }

  tbody {
    tr {
      &:nth-child(odd) {
        background: ${mix(0.48, brand.grey.grey1, brand.white)};
      }

      &:nth-child(even) {
        background: ${mix(0.48, brand.grey.otherGrey, brand.white)};
      }

      th {
        border: 2px solid ${brand.white};
        color: ${brand.white};
        ${fonts.helvetica.bold};
        font-size: 18px;
        letter-spacing: -0.01em;
        line-height: 22px;
        padding: 12px 16px;
        text-align: left;
      }

      td {
        border: 2px solid ${brand.white};
        ${fonts.helvetica.regular};
        font-size: 16px;
        letter-spacing: -0.01em;
        line-height: 20px;
        padding: 12px 16px;
        text-align: left;
      }
    }
  }
`;
export const contentStyles = css `
  h1,
  .h1-styles {
    ${h1}
  }

  h2,
  .h2-styles {
    ${h2}
  }

  h3,
  .h3-styles {
    ${h3}
  }

  h4,
  .h4-styles {
    ${h4}
  }

  h5,
  .h5-styles {
    ${h5}
  }

  h6,
  .h6-styles {
    ${h6}
  }

  .h6-bold-styles {
    ${h6Bold}
  }

  p {
    ${paragraph}
  }

  p.subhead,
  span.subhead {
    ${subhead}
  }

  p.hero,
  span.hero {
    ${paragraphHero}
  }

  p.small,
  span.small {
    ${paragraphSmall}
  }

  p.micro,
  span.micro {
    ${micro}
  }

  p.content-sub {
    ${contentSub}
  }

  a {
    ${link}
  }

  ol,
  ul {
    ${paragraphStyles};
    font-size: 18px;
    line-height: 26px;
    letter-spacing: -0.01em;
    margin: 0 0 0.5em;

    @media ${from(Device.TabletSmall)} {
      font-size: 18px;
      line-height: 28px;
    }

    @media ${from(Device.TabletLarge)} {
      font-size: 18px;
      line-height: 28px;
    }

    @media ${from(Device.DesktopLarge)} {
      font-size: 18px;
      line-height: 36px;
    }
  }

  ol {
    list-style: decimal;
    padding-left: 1.2em;
  }

  ul {
    list-style: disc;
    padding-left: 1.2em;
  }

  li span {
    display: inline;
  }

  blockquote {
    ${blockquote};
  }

  hr {
    display: block;
    background: currentColor;
    border: 0;
    height: 4px;
    margin: 40px 0;
    padding: 0;
    width: 100%;

    @media ${from(Device.Tablet)} {
      margin: 80px 0;
    }
  }

  table {
    ${table};
  }

  .responsive-table {
    position: relative;
    overflow-x: auto;
  }

  .brand-black {
    color: ${brand.black};
  }

  .brand-blue {
    color: ${brand.blue.base};
  }

  .brand-sectors-defence-purple {
    color: ${brand.sectors.defencePurple};
  }

  .brand-sectors-energy-green {
    color: ${brand.sectors.energyGreen};
  }

  .brand-sectors-marine-blue {
    color: ${brand.sectors.marineBlue};
  }

  .brand-sectors-nuclear-orange {
    color: ${brand.sectors.nuclearOrange};
  }

  .brand-sectors-oil-gas-grey {
    color: ${brand.sectors.oilGasGrey};
  }

  .brand-sectors-transport-red {
    color: ${brand.sectors.transportRed};
  }

  .brand-white {
    color: ${brand.white};
  }

  .brand-yellow {
    color: ${brand.yellow.base};
  }

  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }
`;
